"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AddProductToCurrentInventoryRequest = _interopRequireDefault(require("../model/AddProductToCurrentInventoryRequest"));

var _AppResourcesInventoriesSchemasProduct = _interopRequireDefault(require("../model/AppResourcesInventoriesSchemasProduct"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _CreateInventoryRequest = _interopRequireDefault(require("../model/CreateInventoryRequest"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _Inventory = _interopRequireDefault(require("../model/Inventory"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* Inventories service.
* @module api/InventoriesApi
* @version 0.17
*/
var InventoriesApi = /*#__PURE__*/function () {
  /**
  * Constructs a new InventoriesApi. 
  * @alias module:api/InventoriesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function InventoriesApi(apiClient) {
    _classCallCheck(this, InventoriesApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Add a product to the current inventory of a given kitchen's location
   * **Scopes**: - `inventories:read` - `inventories:write` - `kitchens:read` - `locations:read`  Register a product within the current kitchen's location inventory. If it already exists within the current inventory, we'll just update the quantity associated with this inventory item. Otherwise, we'll create a new item with the provided unit and quantity. In any case, the item will be considered as `COMPLETED` within the inventory.  If no inventory are currently opened for the kitchen's next shift, a new one will be created before registering the product in the inventory.
   * @param {String} locationUuid 
   * @param {module:model/AddProductToCurrentInventoryRequest} addProductToCurrentInventoryRequest 
   * @param {Object} opts Optional parameters
   * @param {Boolean} opts.refreshProductNeeds  (default to false)
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppResourcesInventoriesSchemasProduct} and HTTP response
   */


  _createClass(InventoriesApi, [{
    key: "addProductToCurrentInventoryWithHttpInfo",
    value: function addProductToCurrentInventoryWithHttpInfo(locationUuid, addProductToCurrentInventoryRequest, opts) {
      opts = opts || {};
      var postBody = addProductToCurrentInventoryRequest; // verify the required parameter 'locationUuid' is set

      if (locationUuid === undefined || locationUuid === null) {
        throw new Error("Missing the required parameter 'locationUuid' when calling addProductToCurrentInventory");
      } // verify the required parameter 'addProductToCurrentInventoryRequest' is set


      if (addProductToCurrentInventoryRequest === undefined || addProductToCurrentInventoryRequest === null) {
        throw new Error("Missing the required parameter 'addProductToCurrentInventoryRequest' when calling addProductToCurrentInventory");
      }

      var pathParams = {
        'location_uuid': locationUuid
      };
      var queryParams = {
        'refresh_product_needs': opts['refreshProductNeeds']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AppResourcesInventoriesSchemasProduct["default"];
      return this.apiClient.callApi('/locations/{location_uuid}/inventories', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Add a product to the current inventory of a given kitchen's location
     * **Scopes**: - `inventories:read` - `inventories:write` - `kitchens:read` - `locations:read`  Register a product within the current kitchen's location inventory. If it already exists within the current inventory, we'll just update the quantity associated with this inventory item. Otherwise, we'll create a new item with the provided unit and quantity. In any case, the item will be considered as `COMPLETED` within the inventory.  If no inventory are currently opened for the kitchen's next shift, a new one will be created before registering the product in the inventory.
     * @param {String} locationUuid 
     * @param {module:model/AddProductToCurrentInventoryRequest} addProductToCurrentInventoryRequest 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.refreshProductNeeds  (default to false)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppResourcesInventoriesSchemasProduct}
     */

  }, {
    key: "addProductToCurrentInventory",
    value: function addProductToCurrentInventory(locationUuid, addProductToCurrentInventoryRequest, opts) {
      return this.addProductToCurrentInventoryWithHttpInfo(locationUuid, addProductToCurrentInventoryRequest, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new inventory for a given kitchen's location
     * **Scopes**: - `inventories:write` - `locations:read`  Create a new empty inventory for the kitchen's location which can be used to enumerate stored products within its stock.
     * @param {String} locationUuid 
     * @param {module:model/CreateInventoryRequest} createInventoryRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Inventory} and HTTP response
     */

  }, {
    key: "createInventoryWithHttpInfo",
    value: function createInventoryWithHttpInfo(locationUuid, createInventoryRequest) {
      var postBody = createInventoryRequest; // verify the required parameter 'locationUuid' is set

      if (locationUuid === undefined || locationUuid === null) {
        throw new Error("Missing the required parameter 'locationUuid' when calling createInventory");
      } // verify the required parameter 'createInventoryRequest' is set


      if (createInventoryRequest === undefined || createInventoryRequest === null) {
        throw new Error("Missing the required parameter 'createInventoryRequest' when calling createInventory");
      }

      var pathParams = {
        'location_uuid': locationUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Inventory["default"];
      return this.apiClient.callApi('/locations/{location_uuid}/inventories', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new inventory for a given kitchen's location
     * **Scopes**: - `inventories:write` - `locations:read`  Create a new empty inventory for the kitchen's location which can be used to enumerate stored products within its stock.
     * @param {String} locationUuid 
     * @param {module:model/CreateInventoryRequest} createInventoryRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Inventory}
     */

  }, {
    key: "createInventory",
    value: function createInventory(locationUuid, createInventoryRequest) {
      return this.createInventoryWithHttpInfo(locationUuid, createInventoryRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return InventoriesApi;
}();

exports["default"] = InventoriesApi;